export default "__VITE_ASSET__835d1f7a__"